import React from 'react';
import { Zap, Layers, Shield, Building2, Wrench, Clock } from 'lucide-react';

const WhyChooseUsSection = () => {
  const reasons = [
    {
      icon: Zap,
      title: 'Rapid Response Times',
      description: 'Quick deployment and fast solutions when you need them most',
    },
    {
      icon: Layers,
      title: 'Multi-Disciplinary Expertise',
      description: 'One trusted partner for all your engineering needs',
    },
    {
      icon: Shield,
      title: 'Fully Insured & Certified',
      description: 'Complete peace of mind with full liability coverage',
    },
    {
      icon: Building2,
      title: 'Commercial & Domestic Coverage',
      description: 'Serving homes, businesses, and everything in between',
    },
    {
      icon: Wrench,
      title: 'Fully Equipped Engineers',
      description: 'Professional teams ready with the right tools',
    },
    {
      icon: Clock,
      title: 'Always Available',
      description: 'Round-the-clock support when you need us most',
    },
  ];

  return (
    <section id="why-choose-us" className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Why Choose H.A.R.P Solutions LTD
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
            We combine practical expertise with dependable service to give our clients 
            complete confidence from first call to final fix.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group p-8 bg-gray-800/50 border border-gray-700 rounded-xl hover:border-amber-600/50 transition-all duration-300 hover:shadow-xl hover:shadow-amber-500/10 hover:-translate-y-1"
            >
              <div className="flex flex-col items-start space-y-4">
                <div className="p-3 bg-amber-600/20 rounded-lg group-hover:bg-amber-600/30 transition-colors duration-300">
                  <reason.icon className="w-7 h-7 text-amber-500" />
                </div>
                <h3 className="text-xl font-bold text-white">
                  {reason.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
